const tags = {
    en: {
        SOCIAL_MEDIA: 'socialMedia',
        INFOGRAPHIC: 'infographic',
        ANIMATION: 'animation',
        PUBLICATION: 'publication',
        ILLUSTRATION: 'illustration',
        VISUAL_IDENTITY: 'visualIdentity',
        WEB: 'web',
        WOMEN: 'women',
        WORK: 'work',
        ESG: 'esg',
        EQUALITY: 'equality',
        TERRITORY: 'territory',
        POLITICS: 'politics',
        ENVIRONMENT: 'environment',
        HUMAN_RIGHTS: 'humanRights',
    },
    pt: {
        SOCIAL_MEDIA: 'mídiasSociais',
        INFOGRAPHIC: 'infográfico',
        ANIMATION: 'animação',
        PUBLICATION: 'publicação',
        ILLUSTRATION: 'ilustração',
        VISUAL_IDENTITY: 'identidadeVisual',
        WEB: 'web',
        WOMEN: 'mulheres',
        WORK: 'trabalho',
        ESG: 'esg',
        EQUALITY: 'igualdade',
        TERRITORY: 'território',
        POLITICS: 'política',
        ENVIRONMENT: 'meioAmbiente',
        HUMAN_RIGHTS: 'direitosHumanos',
    }
}

export { tags };